type Result<T extends Record<PropertyKey, PropertyKey>> = {
  [P in keyof T as T[P]]: P;
};

export const invertObject = <T extends Record<PropertyKey, PropertyKey>>(
  obj: T,
): Result<T> =>
  Object.keys(obj).reduce((result, key) => {
    const value = obj[key];
    result[value] = key;
    return result;
  }, {} as any);
